/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_SkuInputs */

const vi_packaging_bom_sku = /** @type {(inputs: Packaging_Bom_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU`)
};

/**

* @param {Packaging_Bom_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_sku = /** @type {((inputs?: Packaging_Bom_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_sku(inputs)
});